import { render, staticRenderFns } from "./hospitals.vue?vue&type=template&id=9ced5bf2&"
import script from "./hospitals.vue?vue&type=script&lang=js&"
export * from "./hospitals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports